export const getLastEmployeeId = state => state.employee.lastInteractiveId;